/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the VapidPublicKeyResponse interface.
 */
export function instanceOfVapidPublicKeyResponse(value) {
    if (!('publicKey' in value) || value['publicKey'] === undefined)
        return false;
    return true;
}
export function VapidPublicKeyResponseFromJSON(json) {
    return VapidPublicKeyResponseFromJSONTyped(json, false);
}
export function VapidPublicKeyResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'publicKey': json['public_key'],
    };
}
export function VapidPublicKeyResponseToJSON(json) {
    return VapidPublicKeyResponseToJSONTyped(json, false);
}
export function VapidPublicKeyResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'public_key': value['publicKey'],
    };
}
